export const preColor = [
  '#FFFFFF',
  '#191919',
  '#E7E6E6',
  '#40546C',
  '#459CDA',
  '#FD7603',
  '#E34D59',
  '#FFBE00',
  '#3771CA',
  '#5AB033',

  '#F2F2F2',
  '#808080',
  '#D0CECE',
  '#D5DCE6',
  '#DBEBF8',
  '#FFE4D4',
  '#FFDBDF',
  '#FFF2C7',
  '#D8E3F5',
  '#DFF1D7',

  '#D9D9D9',
  '#595959',
  '#B0ABAB',
  '#ABB9CC',
  '#B7D8F1',
  '#FFC9A8',
  '#FFB1B9',
  '#FFE68D',
  '#B0C7EA',
  '#BEE2AF',

  '#BFBFBF',
  '#404040',
  '#777171',
  '#8097B2',
  '#94C4EA',
  '#FFAE7B',
  '#F98490',
  '#FFD94B',
  '#89AAE0',
  '#9ED386',

  '#A6A6A6',
  '#262626',
  '#3C3838',
  '#303F52',
  '#0075BB',
  '#D45200',
  '#C73947',
  '#C78F00',
  '#24549C',
  '#448426',

  '#7F7F7F',
  '#0D0D0D',
  '#181717',
  '#202A36',
  '#054E7D',
  '#8E3700',
  '#A80D1D',
  '#845F00',
  '#193867',
  '#2D591A',
]
